import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { foodGallery } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          {/* <CFImage src={mobileGallery} w="100%" alt="Food Gallery" /> */}
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" m="0 auto" mb="30px">
          {/* <CFImage src={foodGallery} w="100%" alt="Food Gallery" /> */}
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
